import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import { isEmpty } from 'lodash';
import colors from '@/styles/color.scss';
import BodyAttributeRecognition from '@blade-sxp/task-management/components/deviceDarwer/body-attribute-recognition.vue';
import { QueueUpModule } from '@blade-sxp/task-management/store/queueUp';
let RoiDataItem = class RoiDataItem extends Vue {
    polygons;
    roiType;
    activeTask;
    videoPlayStatus;
    roiDisabled;
    placeholder;
    colors = colors;
    disabled = false;
    visible = false;
    roi = require('@blade-sxp/task-management/assets/roi.png'); // roi 多边形
    line = require('@blade-sxp/task-management/assets/line.png'); // line
    bodyFrame = require('@blade-sxp/task-management/assets/bodyframe.png'); // Bodyframe
    tipInfor = {
        tipImg: '',
        tipType: '',
    };
    enableAttributesAnalysis = false;
    activeBackgroundId = '';
    get graphHoverId() {
        return MapPolygonsModule.graphHoverId;
    }
    get crowdType() {
        return this.$route.name === 'crowdTask';
    }
    get isShowRoiMap() {
        return this.polygons && this.polygons.length;
    }
    get isEnableAttributes() {
        return this.roiType === 'modelType';
    }
    get switchValue() {
        return QueueUpModule.enableAttributesAnalysis;
    }
    onChangeValue(val) {
        this.enableAttributesAnalysis = val;
    }
    getRoiType(val) {
        switch (val) {
            case 'lines':
                this.tipInfor.tipImg = this.line;
                this.tipInfor.tipType = 'lines';
                break;
            case 'bodyFrame':
                this.tipInfor.tipImg = this.bodyFrame;
                this.tipInfor.tipType = 'BodyFrame';
                break;
            default:
                this.tipInfor.tipImg = this.roi;
                this.tipInfor.tipType = 'ROI';
        }
    }
    getPolygons(val) {
        if (this.activeTask !== 'crowdCount') {
            if (this.roiType !== 'bodyFrame') {
                if (val.length === 1) {
                    this.disabled = true;
                }
                else {
                    this.disabled = false;
                }
            }
        }
    }
    getGraphHover(id) {
        if (this.activeTask !== 'crowdCount' && this.activeBackgroundId !== id) {
            this.activeBackgroundId = id;
        }
    }
    startDraw() {
        this.$emit('start-draw', true);
    }
    getI18n(tip) {
        return this.$i18n.t(tip);
    }
    deleteRoiArea(id) {
        this.$confirm(`${this.getI18n('roiTip')}`, `${this.getI18n('tip')}`, {
            confirmButtonText: `${this.getI18n('confirm')}`,
            cancelButtonText: `${this.getI18n('cancel')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            type: 'warning',
        })
            .then(() => {
            this.$emit('delete-roi-area', id);
        })
            .catch(() => { });
    }
    showRoiMap() {
        const data = MapPolygonsModule.temporarySaveData;
        if (!isEmpty(data)) {
            data.forEach((item) => {
                MapPolygonsModule.updataMapPolygonMap(item);
            });
        }
        this.$emit('show-roi-map', true);
    }
    roiAreaHover(id) {
        if (id === this.activeBackgroundId) {
            return colors.deviceCascaderBg;
        }
        else {
            return colors.white;
        }
    }
    mouseenterGetId(graph) {
        if (graph.type === 'rect') {
            MapPolygonsModule.updataGraphHover(graph.id);
        }
    }
    changeValue() {
        QueueUpModule.updataEnableAttributesAnalysis(this.enableAttributesAnalysis);
    }
};
__decorate([
    Prop({})
], RoiDataItem.prototype, "polygons", void 0);
__decorate([
    Prop({ default: 'roiArea', type: String })
], RoiDataItem.prototype, "roiType", void 0);
__decorate([
    Prop({ default: '', type: String })
], RoiDataItem.prototype, "activeTask", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], RoiDataItem.prototype, "videoPlayStatus", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], RoiDataItem.prototype, "roiDisabled", void 0);
__decorate([
    Prop({ default: '' })
], RoiDataItem.prototype, "placeholder", void 0);
__decorate([
    Watch('switchValue', { immediate: true })
], RoiDataItem.prototype, "onChangeValue", null);
__decorate([
    Watch('roiType', { immediate: true })
], RoiDataItem.prototype, "getRoiType", null);
__decorate([
    Watch('polygons', { immediate: true, deep: true })
], RoiDataItem.prototype, "getPolygons", null);
__decorate([
    Watch('graphHoverId', { deep: true })
], RoiDataItem.prototype, "getGraphHover", null);
RoiDataItem = __decorate([
    Component({
        name: 'RoiDataItem',
        components: {
            'body-attribute-recognition': BodyAttributeRecognition,
        },
        i18n: {
            messages: {
                en: {
                    roiArea: 'ROI Area',
                    roiTip: 'Are you sure to delete this ROI?',
                    tip: 'Tips',
                    confirm: 'confirm',
                    cancel: 'cancel',
                    info: 'Before drawing a new ROI, delete the existing ROI',
                    examples: 'Examples',
                },
                zh: {
                    roiArea: 'ROI 区域',
                    roiTip: '确认删除该ROI吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    examples: '示例',
                    info: '在绘制新的roi之前，请先删除已存在的roi',
                },
            },
        },
    })
], RoiDataItem);
export default RoiDataItem;
